import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DateInput from 'src/app/components/DateInput';
import inputPropTypes from 'src/app/propTypes/input';
import {
  experienceDateFromChange,
  experienceDateFromBlur,
  experienceDateFromFocus
} from 'src/app/redux/actions/registration/experience/experienceDateFrom';
import { experienceDateToBlur } from 'src/app/redux/actions/registration/experience/experienceDateTo';


class ExperienceDatesFromContainer extends React.Component {

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { value, validationMessage } = target;

    dispatch(experienceDateFromChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(experienceDateFromFocus());
  };

  onBlur = ({ target }) => {
    const { dispatch, value: date, dateTo, dateToInputRef, stillWorking } = this.props;
    const { validationMessage } = target;
    const { current } = dateToInputRef;

    dispatch(experienceDateFromBlur(validationMessage, date, dateTo, stillWorking));
    dispatch(experienceDateToBlur(current.element.validationMessage, dateTo, date));
  };


  render() {
    const { onChange, onFocus, onBlur } = this;
    const {
      value,
      validationMessage,
      markedAsWrong,
      focus,
      apiError,
      inputRef,
      hasWorkExperience,
      sending
    } = this.props;

    return (
      <DateInput label="Od"
                 ref={ inputRef }
                 disabled={ !hasWorkExperience || sending }
                 required={ hasWorkExperience }
                 pattern=".{7}"
                 data-test="input-date-from"
                 { ...{
                   value,
                   validationMessage,
                   markedAsWrong,
                   focus,
                   apiError,
                   onChange,
                   onFocus,
                   onBlur
                 } } />
    );
  }
}

ExperienceDatesFromContainer.propTypes = {
  sending: PropTypes.bool.isRequired,
  stillWorking: PropTypes.bool.isRequired,
  hasWorkExperience: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputRef: PropTypes.object.isRequired,
  ...inputPropTypes
};

const mapStateToProps = (store) => ({
  ...store.experienceDateFromReducer,
  ...store.experienceFormReducer,
  dateTo: store.experienceDateToReducer.value,
  stillWorking: store.experienceDateToReducer.disabled
});

export default connect(mapStateToProps)(ExperienceDatesFromContainer);
